<template>
  <div
    class="w-100 px-5 mb-5 d-flex flex-column justify-content-center align-items-center"
  >
    <b-overlay :show="anyLoading" class="w-100">
      <h5>Login com Certificado Digital</h5>
      <b-form-select v-model="thumbprint" class="my-3" autofocus>
        <b-form-select-option value="0" disabled selected
          >Selecione</b-form-select-option
        >
        <b-form-select-option
          v-for="cert in certificadosValidos"
          :key="cert.thumbprint"
          :disabled="cert.expired"
          :value="cert.thumbprint"
        >
          {{ cert.subjectName }} (por {{ cert.issuerName }})
        </b-form-select-option>
      </b-form-select>
      <div class="d-flex justify-content-center">
        <b-button class="m-1" variant="success" size="sm" @click="login">
          <font-awesome-icon icon="lock" class="mr-2" />
          Entrar
        </b-button>
        <b-button
          variant="outline-secondary"
          class="m-1"
          size="sm"
          @click="recarregar"
        >
          <font-awesome-icon icon="rotate" class="mr-2" />
          Recarregar
        </b-button>
      </div>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import LacunaWebPKI from "web-pki";

import { store } from "@/store";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { PortalError } from "@/types/portal-error";
import usuarioService from "@/services/administracao/usuarioService";

const CompProps = Vue.extend({
  name: "LoginCert",
});

@Component
export default class LoginCert extends mixins(UtilsTS, CompProps) {
  certificados: any = null;
  pki?: LacunaWebPKI;
  thumbprint = "";
  loadingCerts = false;
  login1 = false;

  get anyLoading() {
    return this.loadingCerts || this.login1;
  }
  get certificadosValidos() {
    if (!this.certificados) return [];
    return this.certificados
      ?.filter((c) => c.pkiBrazil && c.pkiBrazil.isPessoaFisica)
      .map((c) => ({
        ...c,
        expired: c.validityEnd < new Date() || c.validityStart > new Date(),
      }));
  }

  async mounted() {
    try {
      store.blockScreen = true;
      this.pki = new LacunaWebPKI(process.env.VUE_APP_LACUNA_LICENSE);
      this.pki.init({
        restPkiUrl: process.env.VUE_APP_REST_PKI_URL,
        ready: this.loadCertificates,
        notInstalled: this.onWebPkiNotInstalled,
        defaultFail: this.onWebPkiError,
      });
    } finally {
      store.blockScreen = false;
    }
  }

  async login(e) {
    if (e) e.preventDefault();
    try {
      this.loadingCerts = true;
      if (!this.thumbprint || this.thumbprint === "") {
        this.$toast.error("Selecione um certificado válido");
        return;
      }
      const token = await usuarioService.loginCertStart();
      //console.log("Token para login com certificado digital recebido", token);
      this.login1 = true;
      this.pki
        ?.signWithRestPki({
          thumbprint: this.thumbprint,
          token,
        })
        .success(async (res) => {
          const respFinish = await usuarioService.loginCertFinish(res);
          this.$emit("dologin", respFinish);
          this.login1 = false;
        })
        .fail((err) => {
          console.error("Falha no pki.signWithRestPki", err);
          this.tratarError(
            new PortalError(
              err.userMessage ||
                "Falha ao assinar digitalmente. Por favor tente novamente em instantes."
            )
          );
          this.login1 = false;
        });
    } catch (e) {
      console.error("Erro ao efetuar login com certificado digital", e);
      this.tratarError(e);
    } finally {
      this.loadingCerts = false;
    }
  }
  async recarregar() {
    this.loadCertificates();
  }

  async loadCertificates() {
    try {
      this.loadingCerts = true;
      this.certificados = null;
      if (this.pki) {
        await this.pki.listCertificates().success((certs) => {
          this.certificados = certs;
        });
      }
    } catch (e) {
      console.error("Erro ao carregar certificados", e);
      this.tratarError(e);
    } finally {
      this.loadingCerts = false;
    }
  }
  onWebPkiNotInstalled(status, msg) {
    console.error("WebPKI não instalado", status, msg);
    this.tratarError(msg);
  }
  onWebPkiFail(status, msg, arg3, arg4) {
    console.error("WebPKI falhou", status, msg, arg3, arg4);
    this.tratarError(msg);
  }
  onWebPkiError(props) {
    console.error("WebPKI erro", props);
    this.tratarError(new PortalError("WebPkiError"));
  }
}
</script>

<style scoped></style>
